import { GESTOR_SETOR_LABELS } from '@/config/gestorAccess'
import {
  JORNADA_SITUACAO_CLASS,
  JORNADA_SITUACAO_LABEL,
  daysUntil,
  formatJornadaDate,
} from '@/components/Gestores/gestorJornadaUi'
import type { GestorJornadaMembro } from '@/services/gestoresService'

export function jornadaSetorLabel(setor: string | null) {
  if (!setor) return '—'
  return GESTOR_SETOR_LABELS[setor] ?? setor
}

export function jornadaPrazoLabel(proximaOneOnOneEm: string) {
  const diff = daysUntil(proximaOneOnOneEm)
  if (diff < 0) return `${Math.abs(diff)}d atraso`
  if (diff === 0) return 'hoje'
  return `em ${diff}d`
}

export function jornadaPrazoClass(proximaOneOnOneEm: string) {
  const diff = daysUntil(proximaOneOnOneEm)
  if (diff < 0) return 'text-red-400'
  if (diff === 0) return 'text-amber-400'
  return 'text-text-muted'
}

export function jornadaRowToneClass(situacao: GestorJornadaMembro['situacao']) {
  if (situacao === 'ATRASADA') return 'bg-red-500/[0.04]'
  if (situacao === 'PROXIMA') return 'bg-amber-500/[0.03]'
  return ''
}

export function jornadaStatusBadge(situacao: GestorJornadaMembro['situacao']) {
  return {
    label: JORNADA_SITUACAO_LABEL[situacao],
    className: JORNADA_SITUACAO_CLASS[situacao],
  }
}

export function jornadaUltimaLabel(ultima: string | null) {
  return ultima ? formatJornadaDate(ultima) : '—'
}

export function jornadaProximaLabel(proxima: string) {
  return formatJornadaDate(proxima)
}

export function jornadaCadenciaLabel(cadenciaDias: number) {
  return `A cada ${cadenciaDias} dias`
}
